import { withInstall } from '@vuesax-plus/utils'

import ConfigProvider from './src/config-provider'

export const VsConfigProvider = withInstall(ConfigProvider)
export default VsConfigProvider

export * from './src/config-provider'
